// extracted by mini-css-extract-plugin
module.exports = {"slider":"CompressCompare_slider__4Sh_I"};